import { render, staticRenderFns } from "./form-practitioners.vue?vue&type=template&id=c0e20110&"
import script from "./form-practitioners.vue?vue&type=script&lang=js&"
export * from "./form-practitioners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports